import "./App.scss";
import { Route, Routes } from "react-router";
import RecentlyUpdatedFiles from "pages/RecentlyUpdatedFiles";
import Home from "pages/Home";
import { ScrollToTop } from "utils/utils";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { selectSpEnvironment } from "state/selectors/Selectors";
import HowTo from "pages/HowTo";
import { loadTextSize } from "state/reducers/TextSizeReducer";
import { loadSpEnvironment } from "state/reducers/SPEnvironmentReducer";

const App = () => {
  const dispatch = useDispatch();
  const SpEnv = useSelector(selectSpEnvironment);
  useEffect(() => {
    dispatch(loadTextSize());
    dispatch(loadSpEnvironment());
  }, [dispatch]);
  return (
    <>
      <div className="bg-white!">
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          {SpEnv !== "logistikportalen" &&
            <>
              <Route path="/recentfiles/:type" element={<RecentlyUpdatedFiles />} />
              <Route path="/howto" element={<HowTo />} />
            </>
          }
        </Routes>
      </div>
    </>
  );
};

export default App;
